/*  MUI  */
import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';

/*  React  */
import React from 'react';

export const ManagedTableSortableArrows = ({
    disabled,
    header,
    setSortState,
    sortState
}) => {
    const { sortableKey, sortableFieldType: fieldType } = header;

    const handleChangeSort = () => {
        setSortState({
            direction: sortState.direction === 'ASC' ? 'DESC' : 'ASC',
            fieldType,
            key: sortableKey
        });
    };

    return (
        <Box data-trackid="renderSortableArrows" className="no-print">
            <IconButton
                data-trackid={
                    sortState.direction === 'DESC'
                        ? 'table_sort_asc'
                        : 'table_sort_desc'
                }
                onClick={() => !disabled && handleChangeSort()}
                size="small"
                sx={{ color: 'icon.textColor' }}
                variant="slim"
            >
                {sortState.direction === 'DESC' &&
                sortState.key === sortableKey ? (
                    <ArrowDropUp />
                ) : (
                    <ArrowDropDown />
                )}
            </IconButton>
        </Box>
    );
};
